import React from 'react';
import ReactCodeInput from 'react-verification-code-input';
import conditionIcon from './../../images/check-outline.svg';
import MiniLoader from 'src/loaders/mini-loader';
import parse from 'html-react-parser';
// styles
const styles = require('./pre-slot-complete-message.scss');

interface IProps {
    currentStep: number;
    isinvalidOTP: boolean;
    isUserVerified: boolean;
    isPnrAdded: boolean;
    termsNextStepClick: any;
    sendOTPToUser: any;
    reSendOTPToUser: any;
    switchOTPChannel: any;
    otpChannel: string;
    pendingOtpChannel: string;
    canSwitchChannel: boolean;
    switchChannelCountdown: number;
    getUserOTP: any;
    verifyOTP: any;
    userGotOTP: boolean;
    didUserGotOTP: any;
    isOTPSubmitted: boolean;
    isLoading: boolean;
    userMobileNumber: number;
    isOTPVerifying: boolean;
    verifyOTPError: boolean;
    sendOTPToUserError: boolean;
    language: string;
    multiLang: any;
}

class PreSlotCompleteMsg extends React.Component<IProps, any> {
    public OTPValue: any = '';
    constructor(props: any) {
        super(props);
    }
    getOTPValue(v) {
        this.OTPValue = v;
    }
    render() {
        const { language, multiLang } = this.props;

        // console.log(this.props)
        // const step = this.props.currentStep;
        let terms: any = '';
        let otpScreen: any = '';
        let invalidOTPScreen: any = '';
        let otpVerificationScreen: any = '';
        // Terms and Conditions screen
        if (this.props.currentStep === 1) {
            terms = (<div className={styles.fade_in}>
                <p className={styles.sub_heading}>{multiLang[`byUsingForArrivalServiceTermText${language}`]}</p>
                <div className={styles.terms_and_condition}>
                    <span className={styles.condition_icon}><img src={conditionIcon} alt='' /></span>
                    <p>{multiLang[`personalEffectsDeclarationArrivalServiceTermText${language}`]}</p>
                </div>
                <div className={styles.terms_and_condition}>
                    <span className={styles.condition_icon}><img src={conditionIcon} alt='' /></span>
                    <p>{multiLang[`customerAllowanceArrivalServiceTermText${language}`]}</p>
                </div>
                <div className={styles.terms_and_condition}>
                    <span className={styles.condition_icon}><img src={conditionIcon} alt='' /></span>
                    <p>{parse(multiLang[`confirmReadArrivalServiceTermText${language}`])}</p>
                </div>
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
                    <button onClick={() => this.props.sendOTPToUser('Sms')} className={styles.btnPrimary}>{multiLang[`sendCodeToPhoneText${language}`].replace('%s', this.props.userMobileNumber)}
                        &nbsp; {this.props.isLoading && this.props.pendingOtpChannel === 'Sms' ? <MiniLoader /> : ''}</button>
                    <button onClick={() => this.props.sendOTPToUser('whatsapp')} className={styles.btnPrimary}><i className='fa fa-whatsapp' aria-hidden='true'></i>&nbsp;{multiLang[`sendCodeToWhatsAppText${language}`]}
                        &nbsp; {this.props.isLoading && this.props.pendingOtpChannel === 'whatsapp' ? <MiniLoader /> : ''}</button>
                </div>
                {this.props.sendOTPToUserError ? <p className={styles.bottomError}>{multiLang[`errorMessageSomethingWentWrong${language}`]}</p> : null}
            </div>)
        }
        // OTP Screen
        if (this.props.currentStep === 2) {
            otpScreen = (
                <div className={styles.fade_in}>
                    <p>{multiLang[`pleaseEnter5DigitCodeText${language}`]}</p>
                    <ReactCodeInput
                        placeholder={['-', '-', '-', '-', '-']}
                        className={styles.varification_OTP}
                        onComplete={(e) => { this.props.getUserOTP(e); this.getOTPValue(e) }}
                        onChange={(e) => { this.props.getUserOTP(e); this.getOTPValue(e) }}
                        fields={5}
                    />
                    <p>{parse(multiLang[`acceptanceOfAirportsText${language}`])}</p>
                    <button disabled={this.props.isOTPVerifying || this.OTPValue.length !== 5} onClick={() => this.props.verifyOTP()} className={[styles.btnPrimary, styles.center].join(' ')}>{multiLang[`buttonSign${language}`]}&nbsp;{this.props.isOTPVerifying ? <MiniLoader /> : ''}</button>
                    {this.props.verifyOTPError ? <p className={styles.bottomError}>{multiLang[`errorMessageSomethingWentWrong${language}`]}</p> : null}
                    {/* RESEND OTP */}
                    {this.props.userGotOTP ? <p className={styles.resend_otp} onClick={() => this.props.didUserGotOTP(false)}>{multiLang[`didNotRecieveMyCodeText${language}`]}</p> : ''}
                    {!this.props.userGotOTP ? (
                        <div className={[styles.fade_in, styles.resend_otp_screen].join(' ')}>
                            <p>{parse(multiLang[`helpingtextWhatToDoWhenNotRecieveCodeSMSORWhatsApp${language}`].replace('%s', this.props.otpChannel === 'whatsapp' ? 'SMS' : 'WhatsApp'))}</p>
                            <div className={styles.resend_actions}>
                                <button onClick={() => this.props.reSendOTPToUser()} className={styles.btnPrimaryOutline}>{multiLang[`ButtonResend${language}`]}&nbsp; {this.props.isLoading && this.props.pendingOtpChannel === this.props.otpChannel ? <MiniLoader /> : ''} </button>
                                <button onClick={() => this.props.switchOTPChannel()} disabled={!this.props.canSwitchChannel} className={styles.btnPrimaryOutline}>{this.props.otpChannel === 'whatsapp' ? multiLang[`ButtonResendSms${language}`] : multiLang[`buttonResendWhatsApp${language}`]}{!this.props.canSwitchChannel ? ` (${this.props.switchChannelCountdown}s)` : ''}&nbsp; {this.props.isLoading && this.props.pendingOtpChannel !== '' && this.props.pendingOtpChannel !== this.props.otpChannel ? <MiniLoader /> : ''} </button>
                            </div>
                        </div>
                    ) : ''}
                    {this.props.sendOTPToUserError ? <p className={styles.bottomError}>{multiLang[`errorMessageSomethingWentWrong${language}`]}</p> : null}
                </div>
            )
        }

        // Invalid OTP SCreen
        if (this.props.isinvalidOTP) {
            invalidOTPScreen = (
                <React.Fragment>
                    <div className={styles.invalid_OTP_screen}>
                        <p>{multiLang[`errorTextWrongCodeEntered${language}`]}.</p>
                        <button onClick={() => this.props.reSendOTPToUser()} className={styles.btnPrimary}>{multiLang[`ButtonResend${language}`]} &nbsp; {this.props.isLoading ? <MiniLoader /> : ''}</button>
                    </div>
                </React.Fragment>
            )
        }

        // OTP verification
        if (this.props.isUserVerified) {
            otpVerificationScreen = <React.Fragment>
                <div className={styles.invalid_OTP_screen}>
                    <button disabled className={[styles.btnPrimary, styles.btnSubmitted].join(' ')}>{multiLang[`buttonSubmitted${language}`]}</button>
                </div>
            </React.Fragment>
        }
        return (
            <React.Fragment>
                {/* step 2 Terms of use */}
                {this.props.isUserVerified ? otpVerificationScreen :
                    <>
                        {/* default condition */}
                        {/* <button onClick={() => this.props.termsNextStepClick(1)} disabled={!this.props.isPnrAdded} style={this.props.currentStep === 0 ? { 'display': 'reset' } : { 'display': 'none' }} className={styles.btnPrimary}>{multiLang[`buttonStart${language}`]}</button> */}
                        {/* 1st step */}
                        {terms}
                        {/* 2nd step */}
                        {otpScreen}
                        {/* invalid OTP Screen */}
                        {invalidOTPScreen}
                    </>
                }
            </React.Fragment >
        );
    }

}

export default PreSlotCompleteMsg;



// WEBPACK FOOTER //
// ./src/components/pre-slot-complete-message/pre-slot-complete-message.component.tsx